class StickyHeader extends HTMLElement {

  constructor() {
    super();
    this.stickyWrapper = this.querySelector('.sticky-header');
    // Set default 0
    this.savedScrollY = 0;
    // Hook into scroll event
    lmScroll.on('scroll', (args) => {
      if(!document.body.classList.contains('header-navigation-mob--is-open')) {
        this.handleScroll(args.scroll.y);
      }
    });

    // Add and remove class to prevent hide header when the menu is open
    document.querySelectorAll('#shopify-section-header .header-navigation__list-item.level-1.has-subnav')?.forEach(item=> {
      item.addEventListener('mouseenter', () => {
        document.body.classList.add('desktop-navigation-hover-active');
      });
    });
    document.querySelectorAll('#shopify-section-header .header-navigation__list-item.level-1.has-subnav')?.forEach(item => {
      item.addEventListener('mouseleave', () => {
        document.body.classList.remove('desktop-navigation-hover-active');
      });
    });

    // Catch click on back button level 2 nav mobile
    const mobileBackTriggers = document.querySelectorAll('.header-navigation__link-back');
    mobileBackTriggers?.forEach((trigger)=>{
      trigger.addEventListener('click', () => {
        let closestToggle = trigger.closest('.header-navigation__list-item');
        closestToggle?.classList.remove('collapsible-is-open');
      });
    });

  }

  handleScroll(scrollY) {

    // Get direction
    const direction = scrollY > this.savedScrollY ? 'down' : 'up';

    // Do things based on scroll direction
    switch(direction) {
      case 'down':
        if(scrollY > 100) {
          this.hideStickyHeader();
        }
        break;
      case 'up':
          this.showStickyHeader();
        break;
      default:
        break;
    }

    // Save it so we can compare it later
    this.savedScrollY = scrollY;
  }

  hideStickyHeader() {
    if (!this.stickyWrapper.classList.contains('header--hide')) {
      if (!document.body.classList.contains('desktop-navigation-hover-active')  && !document.body.classList.contains('header-search-is-open') && !document.body.classList.contains('header-navigation--is-open') && !document.body.classList.contains('header-navigation--mob-is-open')) {
        this.stickyWrapper.classList.add('header--hide');
      }
    }
  }

  showStickyHeader() {
    if (this.stickyWrapper.classList.contains('header--hide')) {
      this.stickyWrapper.classList.remove('header--hide');
    }
  }

}
if(!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

class ToggleSearch extends window.ToggleElementClass {
  constructor() {
    super();
    this.addEventListener('click', () => {
      const searchModalOpenClass = 'header-search-is-open';
      if(document.body.classList.contains(searchModalOpenClass)) {
        document.querySelector('#desktopSearchInModal').focus();
      }
    });
  }
}

if(!customElements.get('toggle-search-modal')) {
  customElements.define('toggle-search-modal', ToggleSearch);
}
